export class otpData {
    campaign_id: number;
    otp: string;
    mobile: string;
    
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}


// WEBPACK FOOTER //
// ./src/app/otpVerify/otp.ts